import { FC, SVGAttributes } from "react";

const KlarnaIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  color = "#0A0B09",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Klarna</title>

    <path
      d="M28 0.913452H4C1.79086 0.913452 0 2.70431 0 4.91345V20.9135C0 23.1226 1.79086 24.9135 4 24.9135H28C30.2091 24.9135 32 23.1226 32 20.9135V4.91345C32 2.70431 30.2091 0.913452 28 0.913452Z"
      fill="#FFB3C7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 18.1635H10V7.66345H12.25V18.1635ZM12.6667 12.9357C14.6631 11.9525 15.9534 9.96582 15.9999 7.66433H18.3632C18.3311 9.8496 17.4292 11.8769 15.8415 13.3807L18.9999 18.1635H15.9999L12.6667 12.9357Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 16.6636C19 17.4919 19.6716 18.1635 20.5001 18.1635C21.3284 18.1635 22 17.4919 22 16.6636C22 15.8351 21.3284 15.1635 20.5001 15.1635C19.6716 15.1635 19 15.8351 19 16.6636Z"
      fill="black"
    />
  </svg>
);

export default KlarnaIconBackground;
